import React from "react";
import "./HomeHoroscope.css";

const HoroscopeSection = () => {
  return (
    <div className="horoscope-container">
      <h3 className="subtitle">HOROSCOPE</h3>
      <h1 className="title">UNDERSTANDING SCIENCE <br /> OF ASTROLOGY</h1>

      <div className="cards-container">
        <div className="card">
          <img src="/assets/H1.png" alt="Aries" />
          <div className="horoscopetext-divisonblock">
          <h2>ARIES</h2>
          <p>The Ram. Ruled by Mars, Aries is the pioneer of the zodiac. You are driven by a courageous, impulsive energy to initiate action and lead the way.</p>
           {/* </div> */}
          </div>
        </div>

        <div className="card">
          <img src="/assets/H2.png" alt="Taurus" />
           <div className="horoscopetext-divisonblock">
          <h2>TAURUS</h2>
          <p>The Bull. Governed by Venus, Taurus builds a world of stability and sensual beauty. You are grounded, patient, and find strength in earthly pleasures.</p>
           </div>
          
        </div>

        <div className="card">
          <img src="/assets/H3.png" alt="Gemini" />
           <div className="horoscopetext-divisonblock">
          <h2>GEMINI</h2>
          <p>The Twins. Led by Mercury, Gemini is the master of communication and curiosity. Your mind is adaptable and quick, constantly seeking new information and connection.</p>
           </div>
          
        </div>

        <div className="card">
          <img src="/assets/H4.png" alt="Cancer" />
           <div className="horoscopetext-divisonblock">
          <h2>CANCER</h2>
          <p>The Crab. Ruled by the Moon, Cancer is the heart of the zodiac. You are deeply intuitive and nurturing, driven to protect and create a safe emotional harbor for yourself and others.</p>
           </div>
          
        </div>

        <div className="card">
          <img src="/assets/H5.png" alt="Leo" />
           <div className="horoscopetext-divisonblock">
          <h2>LEO</h2>
          <p>The Lion. Illuminated by the Sun, Leo is the radiant performer and royal leader. You express yourself with confidence, generosity, and a warm, creative spirit that inspires others.</p>
           </div>
          
        </div>

        <div className="card">
          <img src="/assets/H6.png" alt="Virgo" />
           <div className="horoscopetext-divisonblock">
          <h2>VIRGO</h2>
          <p>The Virgin. Guided by Mercury, Virgo seeks to serve through practical mastery. You have a keen eye for detail and a dedication to improving yourself and the world around you.</p>
           </div>
          
        </div>
      </div>

      <a href="Horoscope"><button className="see-more">See more</button> </a>
    </div>
  );
};

export default HoroscopeSection;
